export default __webpack_public_path__ + "static/media/Janod-stackable-bear-1.92e4b193.jpg";